export enum MODULES {
  IDENTITIES = 'IDENTITIES',
  APPS = 'APPS',
  CONNECTIONS = 'CONNECTIONS',
  DOCUMENTS = 'DOCUMENTS',
  MODULES = 'MODULES',
  NOTICES = 'NOTICES',
  AGENTS = 'AGENTS',
  FUNCTIONS = 'FUNCTIONS',
  DATA_SOURCES = 'DATA_SOURCES',
  MODELS = 'MODELS',
  PROMPTS = 'PROMPTS',
  APPS_AI = 'APPS_AI',
  KNOWLEDGEBASE = 'KNOWLEDGEBASE',
  NOTIFICATIONS = 'NOTIFICATIONS',
  MESSAGES = 'MESSAGES',
  LOGS = 'LOGS',
  WORKFLOWS = 'WORKFLOWS',
  MAILBOX = 'MAILBOX',
  AUTHORIZATION_PERMISSIONS = 'AUTHORIZATION_PERMISSIONS',
  AUTHORIZATION_ROLES = 'AUTHORIZATION_ROLES',
  AUTHORIZATION_PRIVILEGES = 'AUTHORIZATION_PRIVILEGES',
  STORAGE_DRIVE = 'STORAGE_DRIVE',
  STORAGE_RECYCLE_BIN = 'STORAGE_TRASH',
  REFERENCES = 'REFERENCES',
  INTEGRATIONS = 'INTEGRATIONS',
  VIRTUAL_MODULES = 'VIRTUAL_MODULES',
  AUDIT_LOGS = 'AUDIT_LOGS',

  SETUP = 'SETUP',
  SAAS_TENANT = 'SAAS_TENANT',
  SAAS_USERS = 'SAAS_USERS',
  SAAS_SUBSCRIPTIONS = 'SAAS_SUBSCRIPTIONS',
  SAAS_INVOICES = 'SAAS_INVOICES',
  SAAS_SETTINGS = 'SAAS_SETTINGS',
  SAAS_PAYMENTS = 'SAAS_PAYMENTS',
  TICKETS = 'TICKETS',
  SUBSCRIBERS = 'SUBSCRIBERS',
  SUBSCRIPTIONS = 'SUBSCRIPTIONS',
  USERS = 'USERS',
  BILLING = 'BILLING',
}

export enum MODULE_GROUPS {
  AUTHORIZATION = 'AUTHORIZATION',
  INTEGRATIONS = 'INTEGRATIONS',
  VIRTUAL_MODULES = 'VIRTUAL_MODULES',
  STORAGE = 'STORAGE',
  REFERENCES = 'REFERENCES',
}

export enum MODULE_STATUSES {
  ACTIVATE = 'activate',
  DEACTIVATE = 'deactivate',
  HIDDEN = 'hidden',
  DISABLE = 'disable',
}
